// extracted by css-extract-rspack-plugin
export default {"root":"PAK_DfONbsMR6ppB","icon":"TKMGicDM27MBUKvc","content":"C3J6h9BtBYIaJ1JC"};